import { Component } from 'react'
import { parseISO, format } from 'date-fns'
import styled from 'styled-components'

import ShowMoreText from '../../ShowMoreText'

const ReviewContainer = styled.div`
  padding: 1em 0;
  justify-content: 'flex-start';
  display: flex;
  flex: 1;
  flex-direction: column;
`
const ReviewMeta = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: 'flex-start';
  padding: 1rem 0 1.6rem;
`
const ReviewContent = styled.div`
  display: inline-block;
  position: relative;
  padding: 3rem;
  background-color: ${({ theme }) => theme.colors.grey};
  color: #555555;

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 25px;
    height: 25px;
    transform: rotate(45deg);
    top: -5px;
    left: 22px;
    right: auto;
    background-color: ${({ theme }) => theme.colors.grey};
  }
`
const ReviewerWrap = styled.div`
  display: flex;
  flex-direction: column;
  order: 1;
  padding: 0 20px;
  text-align: left;
`
const ProfileImgContainer = styled.div`
  vertical-align: top;
  margin: 0;
`
const ProfileImg = styled.img`
  height: 70px;
  width: 70px;
  border-radius: 50%;
`
const ReviewerName = styled.div`
  font-size: 1.8rem;
  margin-top: 1.2rem;
  color: #555555;
`
const ReviewedDate = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.textGreySemiLight};
`

class Review extends Component {
  render() {
    const { review } = this.props
    const { reviewer, content } = review
    const reviewedDate = format(parseISO(review.created_at), 'd MMM yyyy')

    return (
      <ReviewContainer>
        <ReviewMeta>
          <ProfileImgContainer>
            <ProfileImg src={reviewer.avatar_url} />
          </ProfileImgContainer>
          <ReviewerWrap>
            <ReviewerName>{reviewer.first_name}</ReviewerName>
            <ReviewedDate>{reviewedDate}</ReviewedDate>
          </ReviewerWrap>
        </ReviewMeta>
        <ReviewContent>
          <ShowMoreText>{content}</ShowMoreText>
        </ReviewContent>
      </ReviewContainer>
    )
  }
}

export default Review
